import { ModulePicker } from "@/components/plans/ModulePicker";

export function CustomPlanBuilder({ plan, catalog, mods, setMods }) {
  return (
    <div className="card-surface space-y-4 p-5" data-testid="custom-plan-builder">
      <div>
        <p className="eyebrow">Monte seu plano · {plan.name}</p>
        <p className="mt-1 text-sm text-muted-foreground">Marque os módulos que você quer. O valor é a soma dos módulos escolhidos ({mods.length} selecionado(s)).</p>
      </div>
      <ModulePicker plan={plan} catalog={catalog} value={mods} onChange={setMods} testPrefix="custom-plan" />
      {!mods.length && <p className="text-sm text-amber-600 dark:text-amber-400" data-testid="custom-plan-empty">Escolha pelo menos um módulo para assinar.</p>}
    </div>
  );
}
